import React from "react";
import { Box, Alert, Button, Typography } from "@mui/material/";
import { useTranslation } from "react-i18next";

import styles from "./styles";

export default ({
    showDownload,
    uploadMessage,
    uploadProgress,
    downloadUrl,
    auditId
}) => {
    const { t } = useTranslation();

    return (
        <>
            <Box sx={{ p: 2 }}>
                <Alert severity={!showDownload ? "info" : "warning"}>
                    {!showDownload
                        ? t("messages.exportAuditInitiated")
                        : t("messages.uploadConnectionFailed")}
                </Alert>

                {uploadProgress >= 0 && (
                    <Box role="progressbar" sx={styles.progressBar}>
                        <progress
                            value={uploadProgress}
                            max="100"
                            style={{ width: "100%" }}
                        />
                        <Typography>
                            {`${uploadMessage} ${!showDownload ? uploadProgress + "%" : ""}`}
                        </Typography>
                    </Box>
                )}

                {showDownload && (
                    <Button
                        role="button"
                        variant="contained"
                        href={downloadUrl}
                        download={`audit_${auditId}_export.json`}
                        sx={{ mt: 2 }}
                    >
                        {t("downloadExportFile")}
                    </Button>
                )}
            </Box>
        </>
    );
};
